<template>
    <div class="g-container-box">
        <el-row class="g-header-container">
            <el-col :span="3">
                <div class="g-header-left">熟客控制台</div>
            </el-col>
            <el-col :span="16">
                <nav-head navSel="1"></nav-head>
            </el-col>
            <el-col :span="5">
                <op-head></op-head>
            </el-col>
        </el-row>
        <el-row class="g-view-container">
            <el-col :span="3" class="g-menu-container">
                <sidebar navType="2" defaultSel="1"></sidebar>
            </el-col>
            <el-col :span="21" class="g-center-container">
                <div class="nav_search">
                    <div>
                        <el-button type="primary" @click="dialog = true">+业务员</el-button>
                    </div>
                </div>
                <el-table :data="listData" style="width: 100%">
                    <el-table-column prop="name" label="姓名"></el-table-column>
                    <el-table-column prop="wxName" label="微信号"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="delectQx(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>

            </el-col>
        </el-row>

        <el-dialog title="添加业务员" :visible.sync="dialog" width="30%">
            <div class="order_input1">
                <el-input v-model="name" clearable placeholder="姓名"></el-input>
            </div>
            <div class="order_input2">
                <el-input v-model="wxName" clearable placeholder="微信号"></el-input>
            </div>
            <span slot="footer" class="dialog_footer">
                <el-button type="primary" @click="sendApi">确认添加</el-button>
                <el-button @click="dialog = false">取消</el-button>
            </span>
        </el-dialog>
    </div>
</template>
  
<script>
var util = require("@/common/util.js");
import { API_YWYLIEB, API_YWYSANC, API_YWYXINZ } from "../../assets/js/api.js";
import sidebar from '../../components/sidebar'
import navHead from "../../components/navHead";
import opHead from "../../components/opHead.vue";
export default {
    components: {
        sidebar,
        navHead,
        opHead
    },
    data() {
        return {
            listData: '',
            dialog: false,
            name: '',
            wxName: ''
        }
    },
    created() {
        this.getListData()
    },
    methods: {
        getListData() {
            let params = {}
            util.getData(API_YWYLIEB, params, (res) => {
                this.listData = res.data.data
            })
        },
        delectQx(e) { // 删除权限
            this.$confirm('确定删除业务员？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.closeApi(e.aeId)
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            })
        },
        closeApi(id) {
            let params = new URLSearchParams();
            params.append('aeId', id);
            util.getData(API_YWYSANC, params, (res) => {
                if(res.data.msg == '该信息不存在'){
                    this.$message('该信息不存在')
                    this.dialog = false
                    return
                }
                this.dialog = false
                this.$message('操作成功')
                this.getListData()
            })
        },
        sendApi() {  // 添加权限
            if(this.name == '' || this.wxName == ''){
                this.$message('请完善信息！')
                return
            }
            let params = new URLSearchParams();
            params.append('name', this.name);
            params.append('wxName', this.wxName);
            util.getData(API_YWYXINZ, params, (res) => {
                this.dialog = false
                this.$message('添加成功')
                this.getListData()
            })
        }
    }
}
</script>
  
<style lang="less">
.g-container-box {
    overflow: hidden;
}

.g-header-left {
    background-color: #5c6be8;
    color: #FFF;
    height: 60px;
    line-height: 60px;
    text-align: center;
}

.g-menu-container {
    height: 800px;
    background-color: #fff;
}
.g-center-container {
    overflow: auto;
    height: 800px;
    background-color: #eff3f6;
    padding: 20px;
}

.nav_search {
    margin-top: 10px;
    margin-bottom: 30px;
}

.order_input1 {
    margin-bottom: 20px;
}</style>


// WEBPACK FOOTER //
// src/pages/glyNbmg/index.vue